import React, { useState } from 'react';
import constant from '@components/common/globalization';
import cn from 'classnames';
import style from '../SendReceipt/sendReceipt.module.scss';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';
import { useOutletContext } from 'react-router-dom';
import { LABEL } from '../../../../veriables';

const tableHead = [
  {
    key: 'checkbox',
    name: '',
  },
  {
    key: 'cardType',
    name: FLABEL().REPOST_CARD_TYPE,
  },
  {
    key: 'redactedCardNumber',
    name: FLABEL().REPOST_CARD,
  },
  {
    key: 'cardHolderName',
    name: FLABEL().REPOST_NAME,
  },
  {
    key: 'ticketAmount',
    name: FLABEL().REPOST_TOTAL,
    prefix: `${LABEL().CURRENCY_SYMBOL}`,
  },
  {
    key: 'tipAmount',
    name: FLABEL().REPOST_TIP,
    prefix: `${LABEL().CURRENCY_SYMBOL}`,
  },
  {
    key: 'paymentStatus',
    name: FLABEL().REPOST_PAYMENT_PAYMENT,
  },
];

const RepostPayment = props => {
  const { filteredCheck } = props;
  const [selectedTickets, setSelectedTickets] = useState(null);
  const { getRepostConfirmation } = useOutletContext();

  const handleSelectTickets = ticket => {
    // if the same ticket is clicked again → deselect it
    if (selectedTickets?.id === ticket.id) {
      setSelectedTickets(null);
    } else {
      setSelectedTickets(ticket);
    }
  };

  const tableHeader = () => {
    return (
      tableHead &&
      tableHead.map(item => {
        return (
          <div
            key={item.name}
            className={cn(
              style.headerTiltle,
              item.key === 'checkbox' ? style.flex03 : style.flex1
            )}
          >
            {item.name}
          </div>
        );
      })
    );
  };

  const TicketRow = ({ ticket, index, selectedTickets, onSelect }) => {
    const isSelected = selectedTickets?.id === ticket.id;

    return (
      <div
        className={cn(
          style.contentTxt,
          (index & 1) === 0 ? style.evenIndexTabBg : style.oddIndexTabBg,
          style.tBodyContainer
        )}
      >
        {tableHead.map(column => {
          const { key, prefix } = column;

          if (key === 'checkbox') {
            return (
              <div
                key={`${ticket.id}-checkbox`}
                className={cn(style.headerTiltle, style.flex03, 'pl-2')}
              >
                <input
                  type="checkbox"
                  className={cn(
                    style.input,
                    !ticket.enableRepostPos && style.disabled
                  )}
                  checked={isSelected}
                  onClick={() => handleSelectTickets(ticket)}
                  disabled={!ticket.enableRepostPos}
                />
              </div>
            );
          }

          const value = ticket[key];
          const displayValue =
            typeof value === 'number'
              ? `${prefix || ''}${value.toFixed(2)}`
              : value;

          return (
            <div
              key={`${ticket.id}-${key}`}
              className={cn(style.headerTiltle, style.flex1)}
            >
              {displayValue}
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div className="w-100 h-100 position-relative">
      <div className="fs-16 fw-600">{FLABEL().REPOST_PAYMENT_REPOST_PAYMENT}</div>
      <div className={cn(style.receiptTableConatiner)}>
        <div
          className={cn('text-center', style.contentTxt, style.headerContainer)}
        >
          {tableHeader()}
        </div>

        <div className={cn('w-100 overflowY', style.tbodyWrapper)}>
          {filteredCheck?.tickets?.length > 0 ? (
            filteredCheck?.tickets.map((ticket, index) => (
              <TicketRow
                key={ticket.id}
                ticket={ticket}
                index={index}
                selectedTickets={selectedTickets}
                // onSelect={handleSelectTickets}
              />
            ))
          ) : (
            <div className="h-100 align-items-center col-12 d-flex justify-content-center">
              {FLABEL().REPOST_NO_DATA_AVAILABLE}
            </div>
          )}
        </div>
      </div>
      <div
        className={cn(
          'w-100 d-flex justify-content-center align-items-center position-absolute',
          style.btnContainer
        )}
      >
        <button
          onClick={() => props.onClose('close')}
          className={cn(style.btn, style.cancelBtn)}
        >
          {FLABEL().REPOST_CANCEL}
        </button>
        <button
          disabled={selectedTickets === null}
          className={cn(style.btn, style.receiptBtn)}
          onClick={() => getRepostConfirmation(selectedTickets, filteredCheck)}
        >
          {FLABEL().REPOST_SUBMIT}
        </button>
      </div>
    </div>
  );
};

export default RepostPayment;
